import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TemplatesNew = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.75003 6C3.78354 6 3.00003 5.2165 3.00003 4.25C3.00003 3.2835 3.78354 2.5 4.75003 2.5C5.71653 2.5 6.50003 3.2835 6.50003 4.25C6.50003 5.2165 5.71653 6 4.75003 6ZM2.00003 4.25C2.00003 2.73122 3.23125 1.5 4.75003 1.5C6.26882 1.5 7.50003 2.73122 7.50003 4.25C7.50003 5.76878 6.26882 7 4.75003 7C3.23125 7 2.00003 5.76878 2.00003 4.25ZM10.0001 12.5V9.5H13.0001V12.5H10.0001ZM9.00006 9C9.00006 8.72386 9.22392 8.5 9.50006 8.5H13.5001C13.7762 8.5 14.0001 8.72386 14.0001 9V13C14.0001 13.2761 13.7762 13.5 13.5001 13.5H9.50006C9.22392 13.5 9.00006 13.2761 9.00006 13V9ZM5.65159 10.0985L5.64455 10.0913L4.75006 9.17864L3.85557 10.0913L3.84854 10.0985L3.84136 10.1055L2.92871 11L3.84136 11.8945L3.84854 11.9015L3.85557 11.9087L4.75006 12.8214L5.64455 11.9087L5.65159 11.9015L5.65877 11.8945L6.57142 11L5.65877 10.1055L5.65159 10.0985ZM3.1414 9.39133L1.8644 10.6429C1.66438 10.839 1.66438 11.161 1.8644 11.3571L3.1414 12.6087L4.39298 13.8857C4.58902 14.0857 4.91111 14.0857 5.10715 13.8857L6.35873 12.6087L7.63572 11.3571C7.83575 11.161 7.83575 10.839 7.63572 10.6429L6.35873 9.39133L5.10715 8.11434C4.91111 7.91432 4.58902 7.91432 4.39298 8.11434L3.1414 9.39133ZM9.98208 5.94719L11.4976 3.32219L13.0132 5.94719H9.98208ZM11.0646 2.07219C11.2571 1.73886 11.7382 1.73886 11.9306 2.07219L14.3122 6.19719C14.5047 6.53052 14.2641 6.94719 13.8792 6.94719H9.11605C8.73115 6.94719 8.49059 6.53052 8.68304 6.19719L11.0646 2.07219Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default TemplatesNew
